import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControlLabel, Switch } from '@mui/material';

const SwitchV2 = ({ checked = false, handleChange = () => {}, label = '', disabled = false }) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={handleChange}
            name="checkedA"
            color="primary"
            disabled={disabled}
          />
        }
        label={label}
        disabled={disabled}
        sx={{
          '& .MuiFormControlLabel-label': {
            color: 'primary.main',
          },
        }}
      />
    </FormGroup>
  );
};

SwitchV2.propTypes = {
  checked: PropTypes.bool,
  handleChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SwitchV2;
